import { useGetMatchedRoute } from '@/hooks/routing';
import { type SkinPageConfig, templates } from '@nosinovacao/nosid-mfe-common';
import { useState } from 'react';
import { ContainerContextProvider } from './context/context';
import { ContainerLight } from './light';
import { ContainerWoo } from './woo';
import { ContainerWooDark } from './woo-dark';
import { type ContainerProps } from './props';

export function Container({ children }: Readonly<Pick<ContainerProps, 'children'>>) {
  const match = useGetMatchedRoute();
  const [values, setValues] = useState<Omit<ContainerProps, 'children'>>({});
  if (match.staticData?.anonymous) {
    return <>{children}</>;
  }
  return (
    <ContainerContextProvider value={{ setValues }}>
      <ThemedContainer {...values}>{children}</ThemedContainer>
    </ContainerContextProvider>
  );
}

function ThemedContainer(props: ContainerProps) {
  return templates.getSkinSelector(skinSelector(props));
}
function skinSelector(props: ContainerProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <ContainerWooDark {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <ContainerWoo {...props} />,
      },
    ],
    defaultValue: <ContainerLight {...props} />,
  };
}
